(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invitation', {
            parent: 'entity',
            url: '/inv/{secretKey}',
            data: {
                authorities: [],
                pageTitle: 'ipmApp.invitation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invitation/invitation.html',
                    controller: 'InvitationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invitation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
